// Third Party Library
import { Row, Col, Form, Input, Modal, Space, Button } from "antd"
import { LockOutlined } from "@ant-design/icons"

// Components
import { PrimaryButton } from "../../../../../../components/Decoration/Button"

// Redux Actions
import * as ACTIONS from '../../../../../../../main/services/redux/actions'

export const ModalResetPassword = ({
    open = false,
    onCancel = () => {},
    data = {}
}) => {

    const [ form ] = Form.useForm()

    const onFinish = (e) => {
        ACTIONS.main_user.sso_user_change_password_request(data.email, e.currentPassword, e.newPassword, onCancel)
    }

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            closable={false}
            footer={false}
        >
            <Row style={{ padding: '.5em' }}>
                <Col span={2}>
                    <LockOutlined style={{ fontSize: 20 }} />
                </Col>
                <Col span={20}>
                    <p>Reset password for {data.name}</p>

                    <Form
                        form={form}
                        onFinish={onFinish}
                    >
                        <Form.Item name={'currentPassword'} noStyle>
                            <Input.Password placeholder="Enter current password" />
                        </Form.Item>
                        <Form.Item name={'newPassword'} noStyle>
                            <Input.Password placeholder="Enter new password" />
                        </Form.Item>

                        <Space style={{ marginTop: '18px', float: 'right' }}>
                            <Button onClick={onCancel}>Cancel</Button>
                            <PrimaryButton htmlType={'submit'}>Reset Password</PrimaryButton>
                        </Space>
                    </Form>
                </Col>
            </Row>
        </Modal>
    )
}